<template>
  <div>
    <!-- Cancel Confirmation Message -->
    <div class="style-cancel-confirmed d-flex flex-column">
      <span class="fw-bold">Booking Canceled!</span>
      <img
        src="../../../../assets/icons/green-tick.png"
        class="style-icon mx-auto d-block mt-5"
      />
    </div>

    <!-- Homepage Button -->
    <div class="scss-button-position-bottom">
      <default-button title="Done" @click="goToBooking" />
    </div>
  </div>
</template>

<script>
import DefaultButton from "@/components/button/DefaultButton.vue";
import { mapMutations } from "vuex";

export default {
  name: "BookingCanceled",
  components: {
    DefaultButton,
  },
  methods: {
    goToBooking() {
      this.$router.go(-1);
    },
    ...mapMutations(["getBookingList"]),
  },
  created() {
    // Remove bookinglist item
    this.getBookingList(null);
  },
};
</script>
<style lang="scss" scoped>
.style-cancel-confirmed {
  margin-top: 35%;
  font-size: 18px;
  color: $text-green;
}

.style-icon {
  width: 40%;
  height: 40%;
}
</style>
